import React, { useState } from 'react';
import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { Formik, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import axios from '../../axios';
import { toast } from 'react-toastify';

export function EditFAQ({data, authToken, fetchFAQs, delLoading}) {
    const validationSchema = Yup.object().shape({
        question: Yup.string().required('Required'),
        answer: Yup.string().required('Required'),
    });
    const [show, setShow] = useState(false);

    const handleClose = () => setShow(!show);

    const [faq] = useState(data);

    const updateFAQ = (values, setSubmitting) => {
        axios.put(`/faqs/${faq.faqId}`, values, {
            headers: {
                'Authorization': `Bearer ${authToken}`
            }
        })
        .then((response) => {
            setSubmitting(false);
            if (response.status === 200) {
                toast.success(response.data.message);
                fetchFAQs();
                handleClose();
            } else {
                toast.warn('No response from server');
            }
        })
        .catch((error) => {
            toast.error('Something went wrong');
            setSubmitting(false);
        })
    };

    return (
        <>
            <Button variant="success" size={'sm'} className="me-2" onClick={handleClose} disabled={delLoading}>
                Edit 
                {
                    delLoading &&
                    <Spinner
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                        className='ms-2'
                    />
                }
            </Button>

            <Modal show={show} size="lg" onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Edit FAQ</Modal.Title>
                </Modal.Header>
                <Formik
                    initialValues={{
                        question: faq.question,
                        answer: faq.answer
                    }}
                    validationSchema={validationSchema}
                    onSubmit={(values, {setSubmitting}) => updateFAQ(values, setSubmitting)}
                >
                    {({
                        values,
                        handleChange,
                        handleSubmit,
                        isSubmitting
                    }) => (
                        <Form onSubmit={handleSubmit}>
                            <Modal.Body>
                                <Form.Group className="mb-3">
                                    <Form.Label>Question</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="question"
                                        placeholder="Type Question Here..."
                                        value={values.question}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                    />
                                    <ErrorMessage name='question' component='p' className='error-message' />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label>Answer</Form.Label>
                                    <Form.Control 
                                        as="textarea"
                                        name="answer" 
                                        placeholder="Type answer here..." 
                                        rows={3}
                                        value={values.answer}
                                        onChange={handleChange}
                                        disabled={isSubmitting}
                                    />
                                    <ErrorMessage name='answer' component='p' className='error-message' />
                                </Form.Group>
                            </Modal.Body>
                            <Modal.Footer>
                                <Button variant="secondary" size="sm" type="button" onClick={handleClose} disabled={isSubmitting}>
                                    Close
                                </Button>
                                <Button variant="primary" size="sm" type="submit" disabled={isSubmitting}>
                                    Update 
                                    {
                                        isSubmitting &&
                                        <Spinner
                                            as="span"
                                            animation="border"
                                            size="sm"
                                            role="status"
                                            aria-hidden="true"
                                            className='ms-2'
                                        />
                                    }
                                </Button>
                            </Modal.Footer>
                        </Form>
                    )}
                </Formik>
            </Modal>
        </>
    );
}
